import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';

const CarouselButtons = ({ selectedImageIndex, totalImages, onClick, source, count }) => {
  const [startIndex, setStartIndex] = useState(0);
  const [clickedButtonIndex, setClickedButtonIndex] = useState(null);


  const colors = [
    'bg-[#D7D5D3]', 'bg-[#D5D4CA]', 'bg-[#C3C8C9]', 'bg-[#BCBCBA]', 'bg-[#B0B3AC]', 'bg-[#B6B7BF]', 'bg-[#A1A19F]', 'bg-[#9E9595]', 'bg-[#8A8A8A]', 'bg-[#767982]', 
    'bg-[#7D756A]', 'bg-[#545453]', 'bg-[#413F3D]', 'bg-[#4F4535]', 'bg-[#574231]', 'bg-[#6B4036]', 'bg-[#871D20]', 'bg-[#96382B]', 'bg-[#BD3C26]', 'bg-[#DF1933]', 
    'bg-[#E45C44]', 'bg-[#AF7471]', 'bg-[#E4AEBB]', 'bg-[#F0DFE2]', 'bg-[#F4E0D2]', 'bg-[#D1B898]', 'bg-[#F4C45D]', 'bg-[#E8A93D]', 'bg-[#D0C594]', 'bg-[#C9C2AC]', 
    'bg-[#EFF0E5]', 'bg-[#BEC8AF]', 'bg-[#B1B187]', 'bg-[#BABBA7]', 'bg-[#A1A191]', 'bg-[#9AA2A2]', 'bg-[#A8B8B5]', 'bg-[#819B8E]', 'bg-[#5B6D6C]', 'bg-[#41694E]', 
    'bg-[#578473]', 'bg-[#5E7F87]', 'bg-[#52B8C9]', 'bg-[#8CC9DA]', 'bg-[#A8CDE5]', 'bg-[#91BCE1]', 'bg-[#76A4C7]', 'bg-[#6989A7]', 'bg-[#6B85B7]', 'bg-[#84A6B4]', 
    'bg-[#92ADB1]', 'bg-[#7E9799]', 'bg-[#50738E]', 'bg-[#3F5B7C]', 'bg-[#1F6789]', 'bg-[#123277]'
  ];

  const handleClick = (index) => {
    setClickedButtonIndex(index);
    setTimeout(() => {
      setClickedButtonIndex(null); // Reset the clickedButtonIndex state after a delay
    }, 500); // Adjust the delay as needed
  };

  const handlePrevious = () => {
    setStartIndex((prevStartIndex) =>
      Math.max(0, prevStartIndex - 1) 
    );
  };

  const handleNext = () => {
    setStartIndex((prevStartIndex) =>
      Math.min(totalImages - count, prevStartIndex + 1)
    );
  };

  const renderButtons = () => {
    const buttons = [];
    for (let i = startIndex; i < startIndex + count && i < totalImages; i++) {
      buttons.push(
        <button
          key={i}
          onClick={() => {onClick(i); handleClick(i)} }
          className={`md:w-[100px] md:h-6 w-[40px] h-4 text-white font-bold border border-gray-400 rounded-sm m-2 outline-none focus:outline-none transition-scale ${
            i === clickedButtonIndex ? 'scale-150' : ''} transform skew-x-12 ${colors[i]}`}
          style={{ marginRight: '-8px' }} 
        >
          {/* <img src={source[i]} /> */}
        </button>
      );
    }
    return buttons;
  };

  return (
    <div className="flex justify-center opacity-0 transition-opacity duration-300 hover:opacity-100 items-center">
      <button
        onClick={handlePrevious}
        className="px-4 py-2 mx-2 rounded-full text-gray-700"
      >
        <FontAwesomeIcon icon={faChevronLeft} />
      </button>
      {renderButtons()}
      <button
        onClick={handleNext}
        className="px-4 py-2 mx-2 rounded-full text-gray-700 ml-6"
      >
        <FontAwesomeIcon icon={faChevronRight} />
      </button>
    </div>
  );
};

export default CarouselButtons;